import moment from "moment-timezone"

export const getEndOfDate = date => {
  return moment(date).endOf("date").toISOString()
}
